import {
  GET_TEAM_SUCCESS,
  UPDATE_TEAM_REQUEST,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_FAILURE,
  GET_SERVICE_PROVIDER_METADATA_SUCCESS
} from '../../actions/api/team';
import {
  TEAM_ITEM_INITIALIZE,
  TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE
} from '../../actions/page/Team';

export default function Team(state = {}, action) {
  switch (action.type) {
    case TEAM_ITEM_INITIALIZE:
      const defaults = {
        loading: true,
        saving: false,
        success: true,
        teamName: '',
        ownerUsername: '',
        ownerEmail: '',
        samlConfig: {
          enabled: false,
          loginUrl: '',
          logoutUrl: '',
          entityID: '',
          certificate: ''
        }
      };
      return {
        ...state,
        ...defaults
      };
    case TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE:
      const out = {
        ...state
      };
      if (out.samlConfig == null) {
        out.samlConfig = {};
      }
      out.samlConfig[action.field] = action.newData;
      return out;
    case GET_TEAM_SUCCESS:
      const team = action.response.entities.teams[action.response.result];
      return {
        ...state,
        loading: false,
        teamName: team.teamName,
        ownerUsername: team.ownerUsername,
        ownerEmail: team.ownerEmail,
        samlConfig: team.samlConfig
      };
    case UPDATE_TEAM_REQUEST:
      return {
        ...state,
        saving: true
      };
    case UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        saving: false,
        success: true
      };
    case UPDATE_TEAM_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: true
      };
    case GET_SERVICE_PROVIDER_METADATA_SUCCESS:
      return {
        ...state,
        serviceProviderMetadata: action.response
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/Team.js